module.exports = __webpack_public_path__ + "static/media/facets.21d96053.png";